import { Component, Input, Output, ChangeDetectionStrategy, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ValidationService } from '../validation/validation.service';

@Component({
  selector: 'i-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent implements OnChanges {
  @Input() inpModel: boolean;
  @Input() inpCaption: string;
  @Input() inpDisabled: boolean = false;
  @Input() inpClass: string;
  @Output() inpModelChange = new EventEmitter<boolean>();

  constructor(private validationService: ValidationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    let inpModelChange = changes['inpModel'];
    if (inpModelChange) {
      if (!inpModelChange.isFirstChange()) {
        this.validationService.validate();
      }
    }
  }

  changed() {
    this.inpModelChange.emit(this.inpModel);
  }
}
